export default {
    messages: {
        "navbar.links.discover": "Узнать больше",
        "navbar.links.store": "Магазин",
        "navbar.links.news": "Новости",
        "navbar.links.forum": "Форум",
        "navbar.links.support": "Поддержка",
        "navbar.links.status": "Мой статус",
        "navbar.links.featured": "Доступный контент",
        "navbar.links.rewards": "Получить",
        "navbar.links.library": "Все игры",
        "navbar.links.benefits": "UBISOFT+ награды",
        "navbar.links.subscription": "Настроить подписку",
        "navbar.links.cloud": "Cloud available",
        "heading.all_games": "Все игры",
        "heading.my_games": "Продолжайте играть",
        "heading.popular_games": "Самые популярные игры",
        "heading.recommended_games": "Рекомендовано",
        "action.load_more_games": "Больше игр",
        "action.search_for_game": "Поиск игр",
        "action.launch_game": "Запуск игры",
        "action.activate_game": "Активировать игру",
        "filters.brand": "Серия",
        "filters.game_name": "А - Я",
        "filters.release_date": "Дата выхода",
        "filters.show_all": "Показать все",
        "filters.sort": "Отсортировать по",
        "filters.all": "Все",
        "filters.activated": "Активированные",
        "message.no_activated_games": "У вас нет активированных игр",
        "message.already_owned": "Эта игра у вас уже есть",
        "message.no_available_games": "По вашей подписке нет других доступных игр",
        "message.no_search_results": "По вашему запросу не удалось найти ни одной игры",
        "message.error": "При обработке запроса произошла ошибка",
        "message.refresh_page": "Нажмите, чтобы повторить попытку",
        "message.no_subscription": "У вас нет активной подписки",
        "warning.savefiles_alert.title": "Важная информация по поводу файлов сохранений",
        "warning.savefiles_alert.body": "Улучшение до изданий, доступных в UBISOFT+, повлияет на ваши текущие файлы сохранений, включая внутриигровой прогресс. Если ваша подписка UBISOFT+ закончится, вам потребуется приобрести Season Pass, чтобы загрузить ваши сохранения (включая ваш текущий внутриигровой прогресс). Для большей информации, пожалуйста прочтите статью {here}.",
        "warning.savefiles_alert.body.here": "здесь",
        "warning.savefiles_alert.cancel": "Назад",
        "warning.savefiles_alert.confirm": "Подтвердить",
        "warning.mobile_launch_alert.body": "Игра {game} была добавлена в библиотеку. Чтобы начать игру запустите Uplay на вашем компьютере.",
        "footer.copyright": "© {year} Ubisoft Entertainment. All Rights Reserved. Ubisoft, Ubi.com and the Ubisoft logo are trademarks of Ubisoft Entertainment in the U.S. and/or other countries",
        "footer.links.ubi_link_label": "ubisoft.com",
        "footer.links.terms_of_use_label": "УСЛОВИЯ ИСПОЛЬЗОВАНИЯ",
        "footer.links.privacy_policy_label": "ПОЛИТИКА КОНФИДЕНЦИАЛЬНОСТИ",
        "footer.links.legal_label": "ПРАВОВАЯ ИНФОРМАЦИЯ",
        "hero.title": "Сервис по подписке Ubisoft",
        "hero.subtitle": "БОЛЕЕ 100 ИГР: НЕОГРАНИЧЕННЫЙ ДОСТУП",
        "hero.buttons.subscribe": "Оформить подписку",
        "hero.buttons.login": "Войти",
        "hero.buttons.browse": "Просмотреть все игры",
        "progression.benefits.description": "Разблокируйте наши миры и завоевывайте собственные. Мы хотим наградить вас за вашу лояльность! Получайте новые внутриигровые предметы каждый месяц.\r\nЧем дольше вы остаётесь с Ubisoft+, тем больше внутриигровых наград вы сможете получить!",
        "progression.benefit.singular.reward": "Награда",
        "progression.benefit.plural.reward": "Награды",
        "progression.benefit.singular.benefit": "Выгода",
        "progression.benefit.plural.benefit": "Преимущества",
        "progression.benefit.singular.booster": "Boost",
        "progression.benefit.plural.booster": "Boosts",
        "progression.level.subscribed_for": "Подписка на",
        "progression.level.new_subscriber": "Новый подписчик",
        "progression.level.new_subscribers": "Новые подписчики",
        "progression.level.subscription.first_month": "Первый месяц",
        "progression.level.subscription.starting_with_months": "{months}+ месяца",
        "general.date.month": "месяц",
        "general.date.months": "мес.",
        "general.date.month_remaining": "месяц осталось",
        "general.date.months_remaining": "осталось месяцев",
        "rewards.monthly_rewards": "Ваши награды за месяц",
        "rewards.trial_info": "Free trial",
        "rewards.left": "чтобы получить {rewards_left} наград в этом месяце у вас осталось {time_left}",
        "rewards.current_title": "Текущие награды",
        "rewards.previous_title": "Прошлые награды",
        "rewards.upcoming_title": "Будущие награды",
        "rewards.none_found": "Награда не найдена",
        "rewards.available": "Доступно",
        "rewards.locked": "Недоступно",
        "rewards.claimed": "Получено",
        "rewards.claim": "Получить",
        "rewards.cancel": "Отмена",
        "rewards.confirm": "Хотите получить эту награду?",
        "rewards.none_left": "Для вас нет доступных наград",
        "rewards.already_claimed": "Вы уже претендовали на эту награду",
        "rewards.claim_confirm": "Эта награда теперь доступна в вашей игре",
        "rewards.close": "Закрыть",
        "rewards.load_more": "Еще",
        "external.links.actions.go": "Go",
        "external.links.actions.more_info": "More Info",
        "external.links.actions.learn_more": "Learn More"
    }
};